'use strict';

$(document).ready(function () {
    /* Share url */
    $('.share-url').on('click', function () {
        const suffix = 'utm_source=social_share&utm_medium=social&utm_campaign=product_share';
        let url = window.location.href;
        url = url.indexOf('?') !== -1 ? `${url}&${suffix}` : `${url}?${suffix}`;

        if (navigator.share) {
            navigator.share({
                title: document.title,
                url: url
            });
        }
    });
});
